import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    showModal: Boolean,
    showCalibrateAssessmentNoteModal: Boolean
  }
  static targets = ["modal", "documentsRedirect"];

  connect() {
    if (this.showModalValue) {
      this.showAddContentModal();
    }

    if (this.showCalibrateAssessmentNoteModalValue) {
      this.showCalibrateAssessmentNoteModal();
    }
  }

  handleLater(event) {
    event.preventDefault();
    const redirectTarget = this.documentsRedirectTarget;
    if (redirectTarget) {
      const dataSet = redirectTarget.dataset;
      if (dataSet && dataSet.documentsPresent === "true" && dataSet.redirectUrl) {
        window.location.href = dataSet.redirectUrl;
      } else {
        this.showHideModal();
      }
    } else {
      this.showHideModal();
    }
  }

  showHideModal() {
    this.showAddContentModal();
    this.hideConfirmationModal();
  }

  showAddContentModal() {
    const modal = document.getElementById('customCourseAddContentModal');
    if (modal) { modal.classList.remove("hidden"); }
  }

  hideConfirmationModal() {
    const confirmationModal = document.getElementById('confirmationModal');
    if (confirmationModal) { confirmationModal.classList.add("hidden"); }
  }

  showCalibrateAssessmentNoteModal() {
    const modal = document.getElementById('calibrateAssessmentNoteModal');
    if (modal) { modal.classList.remove("hidden"); }
  }
}
